import timer from '@devices/settings/device_settings/timer.js';
import schedule from '@devices/settings/device_settings/schedule.js';
import night_mode from '@devices/settings/device_settings/night_mode.js';
import actions from '@devices/settings/device_settings/actions.js';
import internet from '@devices/settings/device_settings/internet.js';
import app_setting_plus_rgbw_gen_2 from '@devices/settings/common_settings/app_setting_plus_rgbw_gen_2.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'shellydimmerw1',
	friendly_name: 'Dimmer W1',
	family: 'light',
	isPM: true,
	modes: {
		white: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'forgotten_lights', 'overtemperature'],
			slider: 'brightness',
			brightness: 0,
			color: false,
			color_temp: false,
			effects: false,
			settings: [
				timer,
				schedule,
				night_mode,
				actions,
				internet,
				app_setting_plus_rgbw_gen_2,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode' },
						{ title: 'power_on_default', component: 'power_on_default' },
						{ title: 'button_type', component: 'button_type' },
						{ title: 'minimum_brightness', component: 'min_brightness' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'channel_name', component: 'channel_name' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
